var React = require('react');

function MultipleDevicesIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#b4b4b4;}.cls-2{fill:#fff;}")),React.createElement("path",{"className":"cls-1","d":"M141.75,0H63A63.0007,63.0007,0,0,0,0,63v78.75a63.0007,63.0007,0,0,0,63,63h78.75a63.0007,63.0007,0,0,0,63-63V63A63.0007,63.0007,0,0,0,141.75,0Z","transform":"translate(0 0)","key":1}),React.createElement("path",{"className":"cls-2","d":"M95.9028,141.6379,73.1294,76.0564H72.7q.9126,14.61.9131,27.3926v38.1889H61.9575V63.1121H80.0581l21.8066,62.4663h.3223l22.4512-62.4663h18.1543v78.5258H130.439V102.8044q0-5.8534.2949-15.2539.2959-9.3984.5107-11.3867h-.43l-23.5791,65.4741Z","transform":"translate(0 0)","key":2})]);
}

MultipleDevicesIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","width":"20","height":"20","viewBox":"0 0 204.75 204.75"};

module.exports = MultipleDevicesIcon;

MultipleDevicesIcon.default = MultipleDevicesIcon;
